import { Module } from 'vuex';
import { IRootState } from '@/store';
import {
  PaymentPlanScheduleDateTypeEnum,
  PaymentPlanScheduleTypeEnum,
  PaymentPlanStateEnum
} from '@/models';
import { IPaymentPlanGetters, IPaymentPlanState } from './payment-plan.types';

export const state: IPaymentPlanState = {
  version: 1,
  paymentPlanStateVisuals: [
    {
      value: PaymentPlanStateEnum.Cancelled,
      text: 'Cancelled',
      color: 'cancel',
      icon: 'mdi-close'
    },
    {
      value: PaymentPlanStateEnum.Active,
      text: 'New',
      color: 'draft',
      icon: 'mdi-file-document-outline'
    },
    {
      value: PaymentPlanStateEnum.InProgress,
      text: 'In Progress',
      color: 'submitted',
      icon: 'mdi-alert-circle-check-outline'
    },
    {
      value: PaymentPlanStateEnum.Completed,
      text: 'Scheduled',
      color: 'approved',
      icon: 'mdi-check'
    }
  ],
  paymentPlanScheduleTypeVisuals: [
    {
      value: PaymentPlanScheduleTypeEnum.DownPayment,
      text: 'Down Payment'
    },
    {
      value: PaymentPlanScheduleTypeEnum.NextInstallment,
      text: 'Next Installment'
    },
    {
      value: PaymentPlanScheduleTypeEnum.SpecialInstallment,
      text: 'Special Installment'
    }
  ],
  paymentPlanScheduleDateVisuals: [
    {
      value: PaymentPlanScheduleDateTypeEnum.ExFactory,
      text: 'Before Ex-Factory'
    },
    {
      value: PaymentPlanScheduleDateTypeEnum.SignOff,
      text: 'After Sign Off'
    },
    {
      value: PaymentPlanScheduleDateTypeEnum.Manual,
      text: 'Custom Date'
    }
  ]
};

export const getters: IPaymentPlanGetters = {
  getPaymentPlanStateVisuals: (state: IPaymentPlanState) =>
    state.paymentPlanStateVisuals,
  getPaymentPlanStateVisualByState: (state: IPaymentPlanState) => (
    paymentStateEnum: PaymentPlanStateEnum
  ) => {
    return state.paymentPlanStateVisuals.find(
      stateVisual => stateVisual.value == paymentStateEnum
    );
  },

  getPaymentPlanScheduleVisuals: (state: IPaymentPlanState) =>
    state.paymentPlanScheduleTypeVisuals,
  getPaymentPlanScheduleVisualByState: (state: IPaymentPlanState) => (
    paymentScheduleStateEnum: PaymentPlanScheduleTypeEnum
  ) => {
    return state.paymentPlanScheduleTypeVisuals.find(
      stateVisual => stateVisual.value == paymentScheduleStateEnum
    );
  },

  getPaymentPlanScheduleDateVisuals: (state: IPaymentPlanState) =>
    state.paymentPlanScheduleDateVisuals
};

const namespaced = true;

export const paymentPlan: Module<IPaymentPlanState, IRootState> = {
  namespaced,
  state,
  getters
};
